import { Guid } from "guid-typescript";
import MessageLogAttachment from "./MessageLogAttachment";

class MessageLog {
    id: Guid;
    sender: string;
    subject: string;
    body: string;
    recipientCount: number;
    attachments: MessageLogAttachment[];
    attachmentCount: number;
    created: Date;
    completed: Date;

    constructor(data?: Partial<MessageLog>) {
        Object.assign(this, data);

        if (this.attachments)
            this.attachments = this.attachments.map(item => new MessageLogAttachment(item));

        if (typeof this.created === "string")
            this.created = new Date(this.created);

        if (typeof this.completed === "string")
            this.completed = new Date(this.completed);
    }
}

export default MessageLog;